// src/pages/InvoiceTestPage.jsx
import React, { useState } from 'react';
import { 
  getInvoice, 
  downloadInvoicePDF, 
  cancelInvoice,
  listInvoices
} from '../services/kolaybiFaturaService';

export default function InvoiceTestPage() {
  const [invoiceId, setInvoiceId] = useState('5859702'); // Son test faturanızın ID'si
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);

  // 🔍 Fatura Sorgula
  const handleGetInvoice = async () => {
    setLoading(true);
    setResult(null);
    try {
      console.log('🔍 Fatura sorgulanıyor:', invoiceId);
      const res = await getInvoice(invoiceId);
      setResult(res);
      console.log('✅ Sonuç:', res);
    } catch (error) {
      console.error('❌ Hata:', error);
      setResult({ error: error.message });
    }
    setLoading(false);
  };

  // InvoiceTestPage.jsx içinde

const handleDownloadPDF = async () => {
  setLoading(true);
  setResult(null);
  try {
    console.log('📥 PDF indiriliyor:', invoiceId);
    const res = await downloadInvoicePDF(invoiceId);
    setResult(res);
    
    if (res.success) {
      alert('✅ PDF yeni sekmede açıldı!');
    } else if (res.error === 'not_formalized') {
      alert(`⚠️ ${res.error}\n\nDetay:\n${res.details?.status || ''}`);
    } else {
      alert(`❌ Hata: ${res.error}`);
    }
  } catch (error) {
    console.error('❌ Hata:', error);
    setResult({ error: error.message });
  }
  setLoading(false);
};

  // 🗑️ Fatura İptal
  const handleCancelInvoice = async () => {
    if (!window.confirm('⚠️ Bu faturayı iptal etmek istediğinize emin misiniz? Bu işlem geri alınamaz!')) {
      return;
    }
    
    setLoading(true);
    setResult(null);
    try {
      console.log('🗑️ Fatura iptal ediliyor:', invoiceId);
      const res = await cancelInvoice(invoiceId);
      setResult(res);
      if (res.success) {
        alert('✅ Fatura başarıyla iptal edildi!');
      }
    } catch (error) {
      console.error('❌ Hata:', error);
      setResult({ error: error.message });
    }
    setLoading(false);
  };

  // 📋 Faturaları Listele
  const handleListInvoices = async (filterType = null) => {
    setLoading(true);
    setResult(null);
    try {
      console.log('📋 Faturalar listeleniyor...');
      const filters = filterType ? { type: filterType } : {};
      const res = await listInvoices(filters);
      setResult(res);
      if (res.success && res.invoices) {
        setInvoiceList(res.invoices);
        alert(`✅ ${res.count} adet fatura listelendi!`);
      }
    } catch (error) {
      console.error('❌ Hata:', error);
      setResult({ error: error.message });
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '30px',
        borderRadius: '10px',
        marginBottom: '30px'
      }}>
        <h1 style={{ margin: '0 0 10px 0' }}>📄 Kolaybi E-Fatura Test Paneli</h1>
        <p style={{ margin: 0, opacity: 0.9 }}>Test ortamında fatura işlemlerini test edin</p>
      </div>

      {/* Invoice ID Input */}
      <div style={{ 
        background: 'white', 
        padding: '25px', 
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <label style={{ 
          display: 'block', 
          marginBottom: '10px',
          fontWeight: '600',
          fontSize: '16px'
        }}>
          Invoice ID / Document ID:
        </label>
        <input 
          type="text" 
          value={invoiceId}
          onChange={(e) => setInvoiceId(e.target.value)}
          style={{ 
            width: '100%',
            padding: '12px 15px',
            fontSize: '16px',
            border: '2px solid #e0e0e0',
            borderRadius: '8px',
            boxSizing: 'border-box'
          }}
          placeholder="Fatura ID girin (örn: 5859702)"
        />
      </div>

      {/* Action Buttons */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '15px',
        marginBottom: '20px'
      }}>
        <button 
          onClick={handleGetInvoice} 
          disabled={loading || !invoiceId}
          style={buttonStyle('#4CAF50')}
        >
          🔍 Fatura Sorgula
        </button>

        <button 
          onClick={handleDownloadPDF} 
          disabled={loading || !invoiceId}
          style={buttonStyle('#2196F3')}
        >
          📥 PDF İndir
        </button>

        <button 
          onClick={handleCancelInvoice} 
          disabled={loading || !invoiceId}
          style={buttonStyle('#f44336')}
        >
          🗑️ Fatura İptal
        </button>

        <button 
          onClick={() => handleListInvoices()} 
          disabled={loading}
          style={buttonStyle('#FF9800')}
        >
          📋 Tüm Faturaları Listele
        </button>
      </div>

      {/* Filter Buttons */}
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <h3 style={{ marginTop: 0 }}>Filtreli Listeleme:</h3>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button 
            onClick={() => handleListInvoices('sale_invoice')} 
            disabled={loading}
            style={smallButtonStyle('#9C27B0')}
          >
            Satış Faturaları
          </button>
          <button 
            onClick={() => handleListInvoices('sale_return_invoice')} 
            disabled={loading}
            style={smallButtonStyle('#E91E63')}
          >
            Satış İade
          </button>
          <button 
            onClick={() => handleListInvoices('purchase_invoice')} 
            disabled={loading}
            style={smallButtonStyle('#3F51B5')}
          >
            Alış Faturaları
          </button>
          <button 
            onClick={() => handleListInvoices('purchase_return_invoice')} 
            disabled={loading}
            style={smallButtonStyle('#009688')}
          >
            Alış İade
          </button>
        </div>
      </div>

      {/* Loading Indicator */}
      {loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '30px',
          background: '#FFF3E0',
          borderRadius: '10px',
          marginBottom: '20px'
        }}>
          <div style={{ fontSize: '40px', marginBottom: '10px' }}>⏳</div>
          <p style={{ margin: 0, fontSize: '18px', fontWeight: '500' }}>
            İşlem yapılıyor, lütfen bekleyin...
          </p>
        </div>
      )}

      {/* Result Display */}
      {result && (
        <div style={{ 
          background: result.success ? '#E8F5E9' : '#FFEBEE',
          padding: '25px', 
          borderRadius: '10px',
          border: `2px solid ${result.success ? '#4CAF50' : '#f44336'}`,
          marginBottom: '20px'
        }}>
          <h3 style={{ 
            marginTop: 0,
            color: result.success ? '#2E7D32' : '#C62828'
          }}>
            {result.success ? '✅ İşlem Başarılı' : '❌ Hata Oluştu'}
          </h3>
          <pre style={{ 
            overflow: 'auto', 
            maxHeight: '400px',
            background: 'white',
            padding: '15px',
            borderRadius: '5px',
            fontSize: '13px',
            lineHeight: '1.5'
          }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      {/* Invoice List Display */}
      {invoiceList.length > 0 && (
        <div style={{ 
          background: 'white', 
          padding: '25px', 
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: 0 }}>📋 Fatura Listesi ({invoiceList.length} adet)</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              fontSize: '14px'
            }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={tableHeaderStyle}>ID</th>
                  <th style={tableHeaderStyle}>Seri No</th>
                  <th style={tableHeaderStyle}>Tarih</th>
                  <th style={tableHeaderStyle}>Müşteri</th>
                  <th style={tableHeaderStyle}>Tutar</th>
                  <th style={tableHeaderStyle}>Durum</th>
                  <th style={tableHeaderStyle}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {invoiceList.map((invoice, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <td style={tableCellStyle}>{invoice.commercial_doc_id}</td>
                    <td style={tableCellStyle}>{invoice.header?.serial_no || '-'}</td>
                    <td style={tableCellStyle}>
                      {invoice.header?.issue_date ? 
                        new Date(invoice.header.issue_date).toLocaleDateString('tr-TR') 
                        : '-'}
                    </td>
                    <td style={tableCellStyle}>{invoice.header?.associate?.full_name || '-'}</td>
                    <td style={tableCellStyle}>
                      {invoice.total?.grand_total?.toFixed(2) || '0.00'} ₺
                    </td>
                    <td style={tableCellStyle}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: getStatusColor(invoice.e_document_status),
                        color: 'white',
                        fontSize: '12px',
                        fontWeight: '500'
                      }}>
                        {invoice.e_document_status || 'N/A'}
                      </span>
                    </td>
                    <td style={tableCellStyle}>
                      <button
                        onClick={() => {
                          setInvoiceId(invoice.commercial_doc_id.toString());
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        style={{
                          padding: '6px 12px',
                          background: '#667eea',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        Seç
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Instructions */}
      <div style={{ 
        background: '#E3F2FD', 
        padding: '20px', 
        borderRadius: '10px',
        marginTop: '30px'
      }}>
        <h3 style={{ marginTop: 0 }}>ℹ️ Nasıl Kullanılır?</h3>
        <ol style={{ margin: 0, paddingLeft: '20px' }}>
          <li>Üstteki input'a test etmek istediğiniz fatura ID'sini girin</li>
          <li>İstediğiniz işlem için butona tıklayın</li>
          <li>Sonuçlar altta görünecektir</li>
          <li>Liste görünümünde bir faturayı seçerek işlem yapabilirsiniz</li>
          <li><strong>DİKKAT:</strong> İptal işlemi geri alınamaz!</li>
        </ol>
      </div>
    </div>
  );
}

// Helper Functions
const buttonStyle = (color) => ({
  padding: '15px 25px',
  fontSize: '16px',
  fontWeight: '600',
  background: color,
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
});

const smallButtonStyle = (color) => ({
  padding: '8px 16px',
  fontSize: '14px',
  background: color,
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
});

const tableHeaderStyle = {
  padding: '12px',
  textAlign: 'left',
  fontWeight: '600',
  borderBottom: '2px solid #ddd'
};

const tableCellStyle = {
  padding: '12px',
  textAlign: 'left'
};

const getStatusColor = (status) => {
  const colors = {
    'ready': '#4CAF50',
    'sent': '#2196F3',
    'approved': '#8BC34A',
    'rejected': '#f44336',
    'cancelled': '#9E9E9E'
  };
  return colors[status] || '#607D8B';
};